import { useWindowSize } from "usehooks-ts";

export const useIsLargeScreen = (breakpoint = 1024): boolean => {
  const windowSize = useWindowSize({ debounceDelay: 100 });
  return windowSize.width > breakpoint;
};
